import moment from "moment";
import { DATE_FORMAT, TIME_FORMAT } from "../constants";
export const getFormattedDate = (date, format) => {
  return moment(date).local().format(format);
};
export const basicFormatTimeFromTime = time => {
  return moment(time, "hh:mm:ss").format("hh:mm A");
};
export const formatDatepickerDate = timestamp => {
  return moment(timestamp).local().format("ll");
};
export const formatDateLocalCustom = (date, formatString = "") => {
  return moment(date).local().format(formatString);
};
export const toUploadHour = timestamp => {
  return moment(timestamp).local().format("lll");
};
export const basicFormatDate = timestamp => {
  return moment(timestamp).local().format(DATE_FORMAT);
};
export const basicFormatTime = timestamp => {
  return moment(timestamp).local().format(TIME_FORMAT);
};
export const formatDate = timestamp => {
  return moment(timestamp).local().format("LL");
};
export const formatUTC = timestamp => {
  return moment(timestamp).utc().format("LL");
};
export const formatDateUTCCustom = (date, formatString = "") => {
  return moment(date).utc().format(formatString);
};
export const basicFormatDateUTC = timestamp => {
  return timestamp ? moment(timestamp).utc().format(DATE_FORMAT) : "";
};
export const formatDateCustom = (date, formatString = "") => {
  return moment(date).format(formatString);
};
export const formatShortUTC = timestamp => {
  return moment(timestamp).utc().format("MMM. DD, YYYY");
};
export const formatDateHour = timestamp => {
  return moment(timestamp).local().format("LLL");
};
export const momentLocal = (timestamp, format) => {
  return moment(timestamp).local().format(format).replace(".", "");
};
export const formatDateTimezone = timestamp => {
  const tzName = moment.tz.guess();
  const tzAbbreviation = moment.tz(tzName).zoneAbbr();
  return `${moment(timestamp).local().format("LT")}  (${tzAbbreviation})`;
};
export const momentFormat = (timestamp, format, currentFormat = null) => {
  return moment(timestamp, currentFormat).format(format).replace(".", "");
};
export const formatYYYYMM = (year, month) => {
  return moment(`${year}-${month}`).format("MMMM YYYY");
};
export const unixTimestamp = timestamp => {
  return moment(timestamp).local().valueOf() || 0;
};
export const formatDateExpiration = timestamp => {
  const _moment = moment(timestamp).local();
  return `${_moment.fromNow()} on ${_moment.format("ddd LL")}`;
};
export const formatTimeAgo = (timestamp, removeAgo = false) => {
  if (typeof removeAgo === "object") removeAgo = false;
  const _moment = moment(timestamp).local();
  return `${_moment.fromNow(removeAgo)}`;
};
export const formatDateShort = timestamp => {
  return getFormattedDate(timestamp, "MMM. DD, YYYY");
};
export const isCurrentMonth = month => {
  const currentMonth = moment().utc().format("MMMM YYYY");
  return currentMonth === month;
};
export const convertMonths = number => {
  return moment.months(number - 1);
};
export const daysDifferenceIs = (fromDate, daysAmount) => {
  const today = moment().startOf("day");
  const momentFromDate = moment(fromDate, "YYYY-MM-DD");
  const daysDiff = momentFromDate.diff(today, "days");
  return daysDiff <= daysAmount;
};
export const dateDifference = (fromDate, toDate, unitOfTime = "days") => {
  const momentFromDate = moment(fromDate, "YYYY-MM-DD");
  const momentToDate = moment(toDate, "YYYY-MM-DD");
  return momentFromDate.diff(momentToDate, unitOfTime);
};
export const timeDifference = fromDate => {
  const today = moment().startOf("day");
  const momentFromDate = moment(fromDate);
  const daysDiff = Math.abs(momentFromDate.diff(today, "days"));
  const plural = number => number > 1 ? "s" : "";
  if (daysDiff >= 365) {
    const years = Math.floor(daysDiff / 365);
    return `${years} year${plural(years)}`;
  } else if (daysDiff >= 7) {
    const weeks = Math.floor(daysDiff / 7);
    return `${weeks} week${plural(weeks)}`;
  } else {
    return `${daysDiff} day${plural(daysDiff)}`;
  }
};
export const dateContextColor = date => {
  const today = moment().startOf("day");
  const momentFromDate = moment(date, "YYYY-MM-DD");
  const daysDiff = momentFromDate.diff(today, "days");
  if (daysDiff < 0) {
    //In the past
    return "text-danger bold past-due";
  } else if (daysDiff == 0) {
    //Today
    return "text-success bold active";
  } else if (daysDiff <= 14) {
    //Next 7 days
    return "upcoming";
  } else {
    //More than 7 days
    return "planned";
  }
};
export const formatUnixDate = date => moment.unix(date).local().format("LL");
export const registerHandlebarHelpers = Handlebars => {
  Handlebars.registerHelper("formatDatepickerDate", formatDatepickerDate);
  Handlebars.registerHelper("basicFormatDate", basicFormatDate);
  Handlebars.registerHelper("basicFormatTime", basicFormatTime);
  Handlebars.registerHelper("basicFormatTimeFromTime", basicFormatTimeFromTime);
  Handlebars.registerHelper("formatDate", formatDate);
  Handlebars.registerHelper("formatUTC", formatUTC);
  Handlebars.registerHelper("formatDateUTCCustom", formatDateUTCCustom);
  Handlebars.registerHelper("formatDateLocalCustom", formatDateLocalCustom);
  Handlebars.registerHelper("basicFormatDateUTC", basicFormatDateUTC);
  Handlebars.registerHelper("formatShortUTC", formatShortUTC);
  Handlebars.registerHelper("formatDateHour", formatDateHour);
  Handlebars.registerHelper("formatDateTimezone", formatDateTimezone);
  Handlebars.registerHelper("momentLocal", momentLocal);
  Handlebars.registerHelper("formatYYYYMM", formatYYYYMM);
  Handlebars.registerHelper("unixTimestamp", unixTimestamp);
  Handlebars.registerHelper("formatDateExpiration", formatDateExpiration);
  Handlebars.registerHelper("formatTimeAgo", formatTimeAgo);
  Handlebars.registerHelper("formatDateShort", formatDateShort);
  Handlebars.registerHelper("isCurrentMonth", isCurrentMonth);
  Handlebars.registerHelper("convertMonths", convertMonths);
  Handlebars.registerHelper("daysDifferenceIs", daysDifferenceIs);
  Handlebars.registerHelper("timeDifference", timeDifference);
  Handlebars.registerHelper("dateContextColor", dateContextColor);
  Handlebars.registerHelper("formatDateCustom", formatDateCustom);
  Handlebars.registerHelper("formatUnixDate", formatUnixDate);
};